<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Analítica desglosada de guías por día
            </div>
            <div class="card-body">
                <div>
                    <div class="d-flex justify-content-between mb-4">
                        <analytics-guide-filter :trigger="triggerSearch" /> 
                    </div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Guía">Guía</th>
                                <th scope="col" title="Día">Día</th>
                                <th scope="col" title="Excursión">Excursión</th>
                                <th scope="col" title="Bus">Nombre bus</th>
                                <th scope="col" title="Tamaño bus">Tamaño bus</th>
                                <th scope="col" title="PAX">PAX</th>
                                <th scope="col" title="1/2 PAX">1/2 PAX</th>
                                <th scope="col" title="Total PAX">Total PAX</th>
                                <th scope="col" title="Tipo">Tipo</th>
                                <th scope="col" title="Precio">Precio</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="analyticsBreakdown.length == 0">
                                <td colspan="8">
                                    No hay resultados para los datos introducidos
                                </td>
                            </tr>
                            <analytics-breakdown-day-table-row
                                v-else
                                v-for="(entry, idx) in analyticsBreakdown"
                                :key="entry.id"
                                :row="entry"
                                :idx="idx"
                                :all="analyticsBreakdown"
                            />
                        </tbody>
                        <tfoot>
                            <tr style="border-top: 1px solid gray;" >
                                <td colspan="8"></td>
                                <td class="text-capitalize font-weight-bold float-right" style="padding-top: 10px;">Total</td>
                                <td class="text-capitalize font-weight-bold" style="padding-top: 10px;">{{total}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AnalyticsBreakdownDayTableRow from './AnalyticsBreakdownDayTableRow.vue'
import AnalyticsGuideFilter from './AnalyticsGuideFilter.vue'
import { mapGetters } from "vuex";

export default {
    components: {
        AnalyticsBreakdownDayTableRow,
        AnalyticsGuideFilter
    },
    data: function () {
        return {
            analyticsBreakdown: []
        }
    },
    methods: {
        async triggerSearch() {
            // get filter from store
            const filter = this.guideAnalyticsFilter
            if (filter.day_init != null && filter.day_end != null) {
                this.analyticsBreakdown = await this.$store.dispatch("analytics/retrieveBreakdownGuides", filter)
                if ( this.analyticsBreakdown.length == 0 ) {
                    this.$notify({
                        group: "foo",
                        title: "No hay resultados",
                        text: "No hay resultados para los parámetros de filtrado",
                        type: "warning",
                    });
                }
            } else {
                this.$notify({
                    group: "foo",
                    title: "Seleccionar los parámetros",
                    text: "Es necesario seleccionar como mínimo el rango de fechas de la barra de búsqueda",
                    type: "error",
                });
            }
        },
    },
    computed: {
        ...mapGetters(["guides"]),
        ...mapGetters(["guideAnalyticsFilter"]),
        total() {
            if ( this.analyticsBreakdown.length > 0 ) {
                let total = this.analyticsBreakdown.map( (item) => item.price ).filter( (price) => price != null ).reduce((a,b) => parseFloat(a) + parseFloat(b) , 0)
                
                if ( total.toString().includes('.') ) {
                    total = (Math.round(total * 100) / 100)
                    return total.toString().replace('.', ',') + " €"
                }
                return (Math.round(total * 100) / 100) + " €"
            }
        }
    },
}
</script>